export interface ScheduleEntry {
  until: string | null; // ISO — when to advance to the next entry
  text: string; // display text; use {date} as placeholder
  dateRef?: string; // local date (YYYY-MM-DD) that {date} resolves against
}

export const heroDescriptionSchedule: ScheduleEntry[] = [
  {
    until: '2026-04-17T20:00:00+02:00',
    text: 'Premiere: {date}, 20 Uhr',
    dateRef: '2026-04-17',
  },
  {
    until: '2026-04-18T20:00:00+02:00',
    text: 'Nächste Aufführung: {date}, 20 Uhr',
    dateRef: '2026-04-18',
  },
  {
    until: '2026-04-19T15:00:00+02:00',
    text: 'Nächste Aufführung: {date}, 15 Uhr',
    dateRef: '2026-04-19',
  },
  {
    until: '2026-04-24T20:00:00+02:00',
    text: 'Nächste Aufführung: {date}, 20 Uhr',
    dateRef: '2026-04-24',
  },
  {
    until: '2026-04-25T20:00:00+02:00',
    text: 'Nächste Aufführung: {date}, 20 Uhr',
    dateRef: '2026-04-25',
  },
  {
    until: '2026-04-26T15:00:00+02:00',
    text: 'Letzte Vorstellung: {date}, 15 Uhr',
    dateRef: '2026-04-26',
  },
  { until: null, text: '- Spielpause -' },
];

/** Returns true when the final scheduled event end time has passed. */
export function afterAll(now = Date.now()): boolean {
  const finalEvent = heroDescriptionSchedule
    .filter((entry) => entry.until !== null)
    .at(-1);

  if (!finalEvent?.until) {
    return false;
  }

  return now >= Date.parse(finalEvent.until);
}

export function localDayOffset(dateStr: string): number {
  const ref = new Date(dateStr);
  const now = new Date();
  const refDay = new Date(ref.getFullYear(), ref.getMonth(), ref.getDate());
  const nowDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return Math.round((refDay.getTime() - nowDay.getTime()) / 86_400_000);
}

export function resolveDate(dateRef: string): string {
  const offset = localDayOffset(dateRef);
  if (offset === 0) return 'heute';
  if (offset === 1) return 'morgen';
  const d = new Date(dateRef);
  return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`;
}

export function getHeroDescription(): string {
  const now = Date.now();
  for (const entry of heroDescriptionSchedule) {
    if (entry.until === null || now < Date.parse(entry.until)) {
      if (!entry.text || !entry.dateRef) return entry.text;
      const resolved = resolveDate(entry.dateRef);
      return entry.text
        .replace(
          ' am {date}',
          resolved === 'heute' || resolved === 'morgen'
            ? ` ${resolved}`
            : ` am ${resolved}`,
        )
        .replace('{date}', resolved);
    }
  }
  return '';
}
